import { Box, Typography } from "@mui/material";
import { MediumCustomIcon } from "../../layer00";
import type { IconTypes } from "../../layer00/MediumCustomIcon/types";

export type IChangeState = "NONE" | "INCREASE" | "DECREASE";

export type SentimentChangeCardProps = {
  title: string;
  subTitle: string;
  change: IChangeState;
  stateNumber?: number;
};

export const SentimentChangeCard = (
  props: Readonly<SentimentChangeCardProps>
) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      rowGap="1rem"
    >
      <StateIcon change={props.change} stateNumber={props.stateNumber} />
      <Box>
        <Box textAlign="center">
          <Typography textAlign="center" variant="modalTitle">
            {props.title}
          </Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="modalSubtitle">{props.subTitle}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

const StateIcon = (
  props: Readonly<{
    change: IChangeState;
    stateNumber?: number;
  }>
) => {
  const { bgClass, iconType, stroke } =
    props.stateNumber !== undefined
      ? __score2ViewData(props.stateNumber)
      : __state2ViewData(props.change);
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      className={bgClass}
      sx={{
        borderRadius: ".625rem",
        margin: "auto",
        height: "1.88rem",
        width: "1.88rem",
      }}
    >
      {props.stateNumber !== undefined ? (
        <Typography
          variant="modalTitle"
          sx={{ lineHeight: 1, color: stroke }}
        >
          {props.stateNumber}
        </Typography>
      ) : (
        <MediumCustomIcon stroke={stroke} icon={iconType} />
      )}
    </Box>
  );
};

function __score2ViewData(score: number): {
  bgClass: string;
  stroke: string;
  iconType: IconTypes;
} {
  if (score <= 2) {
    return {
      bgClass: "bg-error-red-10",
      stroke: "var(--error-red-100)",
      iconType: "HORIZONTALLINE",
    };
  }
  if (score === 3) {
    return {
      bgClass: "bg-gold-10",
      stroke: "var(--team-app-score-medium)",
      iconType: "HORIZONTALLINE",
    };
  }
  if (score === 4) {
    return {
      bgClass: "bg-success-green-10",
      stroke: "var(--success-green-120)",
      iconType: "HORIZONTALLINE",
    };
  }
  return {
    bgClass: "bg-teamApp-filter-active-bg",
    stroke: "var(--sapphire-100)",
    iconType: "HORIZONTALLINE",
  };
}

function __state2ViewData(state: IChangeState): {
  bgClass: string;
  stroke: string;
  iconType: IconTypes;
} {
  switch (state) {
    case "INCREASE":
      return {
        bgClass: "bg-success-green-10",
        stroke: "var(--success-green-120)",
        iconType: "TRENDUP",
      };

    case "DECREASE":
      return {
        bgClass: "bg-gold-10",
        stroke: "var(--team-app-warning-icon)",
        iconType: "TENDDOWN",
      };
    case "NONE":
    default:
      return {
        bgClass: "bg-teamApp-filter-active-bg",
        stroke: "var(--sapphire-100)",
        iconType: "HORIZONTALLINE",
      };
  }
}
